import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { getSignatureForId } from '../../redux/selectors/signature';
import { fetchSignature } from '../../redux/sagas/signature/routines';
import { SIGNATURE_TYPE } from '../../constants/signature';

const SignatureBox = ({ signatureId, field }) => {
  const dispatch = useDispatch();
  const signature = useSelector(state => getSignatureForId(state, signatureId));

  useEffect(
    () => {
      if (signatureId) {
        dispatch(fetchSignature({ id: signatureId }));
      }
    },
    [signatureId]
  );

  if (!signature) return <Fragment />;

  const { id, createdAt, signatureType, clientId, volunteerId } = signature;
  const entityId =
    signatureType === SIGNATURE_TYPE.GUEST ? clientId : volunteerId;

  return (
    <Fragment>
      {signatureId > 0 && (
        <span>
          <img
            src={`/signature/${entityId}/${id}/`}
            style={{
              width: 300,
              height: 'auto',
              padding: '15px 0 15px 0'
            }}
            alt="signature"
          />
          <br />
          <span>{moment(createdAt).format('MMMM DD, YYYY, h:mm a')}</span>
          <br />
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={`/signature/details/?id=${signatureId}&field=${field}`}
          >
            View signature details
          </a>
        </span>
      )}
    </Fragment>
  );
};

SignatureBox.propTypes = {
  signatureId: PropTypes.number.isRequired,
  field: PropTypes.string.isRequired
};

export default SignatureBox;
